import clsx from "clsx";
import { ReactNode } from "react";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import useMobile from "src/hooks/useMobile";
import { IButton } from "../Button/Button.types";

interface IGeneralCta {
  title: string;
  description: string;
  icon?: ReactNode;
  buttons?: IButton[];
  className?: string;
}

const GeneralCta: React.FC<IGeneralCta> = ({
  title,
  description,
  icon,
  buttons = [],
  className,
}) => {
  return (
    <div
      className={clsx([
        "relative",
        "flex",
        "w-full",
        "md:gap-4",
        "gap-2",
        "flex-col",
        "md:flex-row",
        "items-center",
        "bg-emerald-400",
        "dark:bg-sky-400",
        "rounded",
        "md:p-2",
        "p-2",
        "overflow-hidden",
        "text-white",
        className,
      ])}
    >
      <div
        className={clsx([
          "flex",
          "w-full",
          "gap-2",
          "md:gap-3",
          "flex-row",
          "md:flex-row",
          "items-start",
          "md:items-center",
        ])}
      >
        {icon && <div className={clsx([])}>{icon}</div>}
        <div className={clsx(["flex", "flex-col", "gap-0"])}>
          <div
            className={clsx([
              "md:text-sm",
              "text-xs",
              "font-medium",
              "text-left",
            ])}
          >
            {title}
          </div>
          <div
            className={clsx([
              "text-left",
              "md:text-sm",
              "text-xs",
              "leading-tight",
              "md:leading-tight",
            ])}
          >
            {description}
          </div>
        </div>
      </div>
      {buttons?.length > 0 && (
        <div
          className={clsx([
            "flex",
            {
              // "w-full": !mobileHorizontal,
            },
            "w-full",
            "flex-grow",
            "justify-end",
            "md:justify-end",
            "flex-shrink-0",
            "md:w-auto",
          ])}
        >
          <ButtonGroup buttons={buttons} align="right" gap={1} />
        </div>
      )}
    </div>
  );
};

export default GeneralCta;
